// BackToTopButton.js
import React, { useEffect, useState } from "react";
import AOS from "aos"; // Import AOS
import "aos/dist/aos.css"; // Import AOS styles

const BackToTopButton = () => {
    const [isVisible, setIsVisible] = useState(false);

    // Initialize AOS
    useEffect(() => {
        AOS.init({
            duration: 800, // Animation duration in milliseconds
        });
    }, []);

    // Show button when the page is scrolled down
    const handleScroll = () => {
        if (window.scrollY > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    // Scroll to top function
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth", // Smooth scroll effect
        });
    };

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    return (
        <>
            {isVisible && (
                <div
                    className="fixed left-4 bottom-4 z-50 cursor-pointer"
                    onClick={scrollToTop}
                    data-aos="fade-up" // AOS animation
                >
                    <div className="transition-transform duration-300 ease-in-out transform hover:scale-110">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="40"
                            height="40"
                            fill="currentColor"
                            className="bg-yellow-500 text-white rounded-full p-2"
                        >
                            <path d="M13 7.828V20h-2V7.828L5.636 13.192 4.222 11.778 12 4l7.778 7.778-1.414 1.414L13 7.828z" />
                        </svg>
                    </div>
                </div>
            )}
        </>
    );
};

export default BackToTopButton;
